// @flow
import { ResourceResponseContext } from 'components/ResourceFill/providers/ResourceResponseProvider'
import { ResourceSessionsContext } from 'components/ResourceFill/providers/ResourceSessionsProvider'
import { ResourceSharedContext } from 'components/ResourceFill/providers/ResourceSharedProvider'
import * as React from 'react'
import { ZentakeContext } from 'utils/ZentakeContext'

function useInsuranceCompanies() {
  const {
    insuranceCompanies,
    fetchInsuranceCompanies,
    privateFetchInsuranceCompanies,
  } = React.useContext(ZentakeContext)

  const { isPacket, source } = React.useContext(ResourceSharedContext) || {}

  const { response } = React.useContext(ResourceResponseContext) || {}

  const { currentSession } = React.useContext(ResourceSessionsContext) || {}

  const onFetchInsuranceCompanies = React.useCallback(() => {
    if (!currentSession?.messageCode || !!insuranceCompanies?.length) return

    if (source !== 'client') {
      privateFetchInsuranceCompanies()
    } else if (isPacket && response?.id && currentSession?.messageCode) {
      fetchInsuranceCompanies({
        messageCode: response?.id,
        packetMessageCode: currentSession?.messageCode,
      })
    } else if (!isPacket) {
      fetchInsuranceCompanies({ messageCode: currentSession?.messageCode })
    }
  }, [
    currentSession?.messageCode,
    fetchInsuranceCompanies,
    insuranceCompanies?.length,
    isPacket,
    privateFetchInsuranceCompanies,
    response?.id,
    source,
  ])

  React.useEffect(() => {
    onFetchInsuranceCompanies()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSession?.messageCode, response?.id])
}

export default useInsuranceCompanies
